import React, { useState } from "react";
import Footer from "./Footer";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
    address: "",
    description: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, email, contact, address, description } = formData;
    const whatsappNumber = "+919477777444"; // Your WhatsApp number

    const message = `Hello, I want to contact you!%0A
    *Name:* ${name}%0A
    *Email:* ${email}%0A
    *Contact:* ${contact}%0A
    *Address:* ${address}%0A
    *Description:* ${description}`;

    const whatsappURL = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <>

      <div className='container mt-1 bg-success p-2 d-flex justify-content-center align-items-center rounded-3' >
        <h2 className="text-center mb-1 text-white">Contact Us</h2>
      </div>

      
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card shadow p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Contact</label>
                  <input
                    type="tel"
                    name="contact"
                    className="form-control"
                    placeholder="Enter your contact number"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    placeholder="Enter your address"
                    value={formData.address}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Description</label>
                  <textarea
                    name="description"
                    className="form-control"
                    rows="3"
                    placeholder="Enter your message"
                    value={formData.description}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn btn-success w-100">
                  Send on WhatsApp
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>


      <section className="container py-5">


        <div className="row justify-content-center">

          <div className="col-md-6">
            <div className="card shadow p-4 text-center">
              <h5 className="mb-3">Get in Touch</h5>
              <p><strong>Address:</strong> Akansha Nursing-Home Ram Sanehi Ghat, Barabanki 225409</p>
              <p><strong>Email:</strong> <a href="mailto:fertilizers.shanti@gmail.com">fertilizers.shanti@gmail.com</a></p>
              <p><strong>Phone:</strong> <a href="tel:+919477777444">+91 9477777444</a></p>
              <a href="Tel:919477777444" class="btn btn-success w-100">
                <i class="fa fa-phone"></i> Call Us
              </a>
            </div>
          </div>
        </div>
      </section>


      <br />
      <div>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3561.005864355224!2d81.5235634!3d26.8079419!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399a2cb12c48662b%3A0x641ef58b5c640242!2sShanti%20Fertilizers!5e0!3m2!1sen!2sin!4v1740980407131!5m2!1sen!2sin" width="100%" height="400" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

      <Footer />
    </>
  );
};

export default Contact;
